import { gettext } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';
import React from 'react';
import { connect } from 'react-redux';
import { DiscoverState } from '../../../../../types';
import { categories } from './categories';
import styles from './WaysToTourSection.module.scss';

interface WaysToTourSectionProps {
    currentPlace: string;
    locationSlug: string;
}

const WaysToTourSection = ({
    currentPlace,
    locationSlug,
}: WaysToTourSectionProps) => {
    return (
        <section className={styles.waysToTourSection}>
            <div className={styles.waysToTourHeader}>
                <Typography as="h2" variant="heading-sm" color="#261B36">
                    {gettext('Ways to tour %(currentPlace)s', { currentPlace })}
                </Typography>
                <Typography variant="body-md" className={styles.headerBlurb}>
                    {gettext(
                        'Explore the best of %(currentPlace)s through these popular event categories.',
                        { currentPlace },
                    )}
                </Typography>
            </div>
            <div className={styles.categoriesContainer}>
                {categories.map((category) => (
                    <a
                        href={`/b/${locationSlug}/${category.key}/`}
                        key={category.key}
                        className={styles.categoryLink}
                    >
                        <img
                            alt={
                                gettext('%(category)s events', {
                                    category: category.label,
                                }) as unknown as string
                            }
                            src={category.imageUrl}
                            className={styles.categoryImage}
                        />

                        <label
                            id={`ways-to-tour-${category.key}`}
                            className={styles.categoryLabel}
                        >
                            <Typography variant="body-md-bold">
                                {category.label}
                            </Typography>
                        </label>
                    </a>
                ))}
            </div>
        </section>
    );
};

const _mapStateToProps = (state: DiscoverState) => ({
    currentPlace: state.location.currentPlace,
    locationSlug: state.location.slug,
});

export default connect(_mapStateToProps)(WaysToTourSection);
